import styled, { css } from 'styled-components';
import { mqMediumMin, mqLargeMin } from 'styled/tools/media-queries';
import { variants } from '.';
import { TypeHeadingSecondary } from '../Typography';

export const HeadlineWrapper = styled.section`
  background: var(--fill-primary);
  padding: var(--spacing-16);

  @media ${mqMediumMin} {
    padding: var(--spacing-24);
  }

  @media ${mqLargeMin} {
    padding: var(--spacing-32);
  }
`;

export const HeadlineContainer = styled.div<{ variant: variants }>`
  display: ${({ variant }) => (variant === '50-50' ? 'grid' : 'flex')};
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  & > * + * {
    margin-top: var(--spacing-16);
  }

  @media ${mqLargeMin} {
    & > * + * {
      margin-top: var(--spacing-24);
    }
  }

  ${({ variant }) => {
    if (variant === 'center') {
      return css`
        @media ${mqMediumMin} {
          align-items: center;
          text-align: center;
        }
      `;
    }

    if (variant === '50-50') {
      return css`
        grid-template-columns: repeat(
          auto-fit,
          minmax(clamp(256px, 50vw, 448px), 1fr)
        );
        gap: var(--spacing-24);

        @media ${mqLargeMin} {
          gap: var(--spacing-32);
        }
      `;
    }

    return '';
  }}
`;

export const HeadlineContent = styled.div<{
  variant: variants;
  $contentMaxInlineSize?: string;
}>`
  max-inline-size: ${(props) => props.$contentMaxInlineSize || '350px'};
  & > * + * {
    margin-top: var(--spacing-32);
  }

  ${({ variant }) =>
    variant === '50-50' &&
    `
    margin-top: 0;
      & > button,
      & > a {
        width: fit-content;
        flex-shrink: 0;
      }
    `}
`;

export const HeadlineTitle = styled(TypeHeadingSecondary)<{
  $titleMaxInlineSize?: string;
}>`
  max-inline-size: ${(props) => props.$titleMaxInlineSize || '500px'};
  margin: 0;
`;
